import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IService } from '@bciti/types';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ServiceStateService } from 'src/app/global/services/service-state/service-state.abstract.service';
import { Service } from 'src/app/global/services/service-state/service-state.model';
import { UpdateServiceAction, UpdateServiceErrorAction, UpdateServiceSuccessAction } from 'src/app/global/store/global.actions';
import { State } from 'src/app/store';

@Component({
    selector: 'app-service-state-edit',
    templateUrl: './service-state-edit.component.html',
    styleUrls: ['./service-state-edit.component.scss'],
})
export class ServiceStateEditComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    serviceId = '';

    service: IService;

    loading = false;

    submitLoading = false;

    constructor(
        private route: ActivatedRoute,
        private serviceStateService: ServiceStateService,
        private router: Router,
        private store: Store<State>,
        private actions$: Actions,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.serviceId = params.get('id');
        });

        this.loading = true;

        // TODO: Implement GetByID with ngrx store
        this.serviceStateService
            .getService(this.serviceId)
            .pipe(
                tap(() => {
                    this.loading = false;
                }),
                takeUntil(this.destroy$),
            )
            .subscribe((service) => {
                this.service = service;
            });
    }

    public goBack(): void {
        this.router.navigate(['services']);
    }

    handleSubmit(payload: Service): void {
        this.submitLoading = true;

        this.store.dispatch(UpdateServiceAction({ service: payload }));

        this.actions$
            .pipe(
                ofType(UpdateServiceSuccessAction, UpdateServiceErrorAction),
                tap(() => (this.submitLoading = false)),
                ofType(UpdateServiceSuccessAction),
                tap(() => this.router.navigate(['services'])),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
